<template>
  <error-component :code="code"/>
</template>

<script>
export default {
  name: 'Index'
  , components: {
    ErrorComponent: () => import('@/components/Modules/Common/Error/Error.vue')
  }
  , computed: {
    code () {
      return (parseInt(this.$route.params.code || '500'))
    }
  }
}
</script>

<style scoped>

</style>